import {
  CustomersSubscriptionActivateClient,
  CustomersSubscriptionClient,
} from './customersSubscription.client';
import { RequestHeader } from '../../../services';
import { CustomersSubscriptionModel } from './customersSubscription.model';

export async function customersSubscriptionProvider(
  type: string,
  requestHeaders?: RequestHeader
): Promise<CustomersSubscriptionModel[]> {
  const response = await new CustomersSubscriptionClient(
    type,
    requestHeaders
  ).get();

  return response as unknown as Promise<CustomersSubscriptionModel[]>;
}

export async function customersSubscriptionActivateProvider(
  type: string,
  requestHeaders?: RequestHeader
): Promise<null> {
  const response = await new CustomersSubscriptionActivateClient(
    type,
    requestHeaders
  ).put();

  return response as unknown as Promise<null>;
}
